import(/* webpackMode: "eager" */ "/vercel/path0/app/docs/api/page.tsx");
